import React from 'react'
import Card from '../components/card'
import FormGroup from '../components/form-group';
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import moment from 'moment';
import GerarAtaService from '../app/service/gerarAtaService';
import ClipLoader from "react-spinners/ClipLoader";
import { mensagemErro} from '../components/toastr';
import {AuthContext} from '../main/provedorAutenticacao';
import CardGroup from '../components/card-group';
import ptBR from 'date-fns/locale/pt-BR';
import 'primeicons/primeicons.css';

class GeracaoAta extends React.Component{

    state = {
        dataReferencia: null,
        loading:false,
        disabled:false,
        mensagem:''
    }
  
    constructor(){
        super();
        this.service = new GerarAtaService();
    }

    limpar = ()=> {
        this.setState({
            mensagem:'',
            dataReferencia: null
        });
    }

    validar(){
        let msgs = [];

        if (!this.state.dataReferencia) {
            msgs.push('O campo data geração da ata é obrigatório.')
        }

        return msgs;
    }


    gerarAta = async () => {
        this.setState({loading: true,
            disabled:true})

        const dadosConsulta = {
             dataReferencia: moment(this.state.dataReferencia).format('DD/MM/yyyy')
             
         }

        try{
            const response = await this.service.gerarAtaPorData(dadosConsulta)
            this.setState({mensagem:response.data});
        }catch( erro){
            mensagemErro(erro.response.data)
        }finally{
            this.setState({loading: false,
                disabled:false})
        }
    }

    consultar = () => {
        this.setState({mensagem:''});
        const msgs = this.validar();
        const size = msgs.length;
     //   alert('msgs.length ', msgs.length > 0);
        if (msgs.length > 0){
            msgs.forEach( (msgs, index) =>{
                mensagemErro(msgs)
            } )
          // return false;
        } else{
            this.gerarAta();
        }
 
      
    }

     render(){

        return (
           <form>
            
           <Card title="Gerar Ata">
            <fieldset disabled ={this.state.disabled}>
             <div className="row">
               <div className="col-md-8 fildeset-form">                     
                    <div className="bs-component">
                        <br/>
                        <CardGroup title="Geracão de Ata por data de refência:"> 
                            {/* <FormGroup label="Período da consulta: *"  htmlFor="inputNome">     */}
                            <FormGroup label="Dia geração da ata: *"  htmlFor="inputNome" >    
                               <div className="row col-md-12">
                                    <div className="col-md-3">
                                            <DatePicker 
                                                selected={this.state.dataReferencia} 
                                                onChange={date => this.setState({dataReferencia: date})} 
                                                className="form-control"  
                                                id="iniDate"
                                                dateFormat="dd/MM/yyyy"
                                                placeholderText = "Data "
                                                locale = {ptBR}
                                            />
                                    </div>
                                </div>
                                <br/>
                                <div className="row col-md-12" style={{color: "blue"}}>
                                     {this.state.mensagem}
                                </div>
                            
                            </FormGroup>
                         </CardGroup>
                            <ClipLoader loading={this.state.loading} size={150} />
                            <br/>
                           <button onClick={this.consultar} className="btn btn-success">
                                <i className="pi pi-undo"> </i> Gerar Ata
                            </button>
                            <button onClick={this.limpar} type="button" className="btn btn-danger">
                                <i className="pi pi-times"> </i> Limpar
                            </button>
                      </div>
                </div>
               </div> 
               </fieldset>
            </Card>
       
            </form> 
        )

    }
}

GeracaoAta.contextType = AuthContext;

export default GeracaoAta;

